import { ACTIONS } from '../constants';

export const resetStages = () => {
  return { type: ACTIONS.RESET_STAGES };
};

export const updateStagesErrors = (errors) => {
  return { payload: errors, type: ACTIONS.UPDATE_STAGES_ERRORS };
};

export const updateStagesLoadings = (loadings) => {
  return { payload: loadings, type: ACTIONS.UPDATE_STAGES_LOADINGS };
};
